import {useStrict} from 'mobx'
import Articles from 'modules/Articles/Store'
import Families from 'modules/Families/Store'
import Customers from 'modules/Customers/Store'
import Taxes from 'modules/Taxes/Store'
import Users from 'modules/Users/Store'
import UI from 'modules/UI/Store'
import Branches from 'modules/Branches/Store'
import Stock from 'modules/Stock/Store'
import SettingsInvoice from 'modules/SettingsInvoice/Store'
import Dashboard from 'modules/Dashboard/Store'
import Reports from 'modules/Reports/Store'
import BusinessUnits from 'modules/BusinessUnits/Store'
import OperationLines from 'modules/OperationLines/Store'
import ReceipLayout from 'modules/ReceiptLayouts/Store'
import PassengerCategories from './modules/PassengerCategories/Store'
import Stretches from 'modules/Stretches/Store'
import DashboardTicket from 'modules/DashboardTicket/Store'
import LicenseStore from 'modules/Licenses/Store'
import DeviceStore from 'modules/Devices/Store'

useStrict(true)

export default class Store {
  articles: Articles = new Articles()
  families: Families = new Families()
  customers: Customers = new Customers()
  taxes: Taxes = new Taxes()
  UI: UI = new UI()
  users: Users = new Users()
  branches: Branches = new Branches()
  stock: Stock = new Stock()
  settingsInvoice: SettingsInvoice = new SettingsInvoice()
  dashboard: Dashboard = new Dashboard()
  reports: Reports = new Reports()
  businessUnits: BusinessUnits = new BusinessUnits()
  operationLines: OperationLines = new OperationLines()
  receipLayouts: ReceipLayout = new ReceipLayout()
  passengerCategories: PassengerCategories = new PassengerCategories()
  stretches: Stretches = new Stretches()
  dashboardTicket: DashboardTicket = new DashboardTicket()
  licenses: LicenseStore = new LicenseStore()
  devices: DeviceStore = new DeviceStore()
}

export interface ICrudStore<T> {
  read(id?: number): any // tslint:disable-line:no-any

  create(data: T | FormData): any // tslint:disable-line:no-any

  update?(id: number, data: T | FormData): any // tslint:disable-line:no-any

  delete?(id: number): any // tslint:disable-line:no-any

  disable?(id: number, disabled: boolean): any // tslint:disable-line:no-any
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Store.ts